<spr-section-module-icon [done]="module.isDone"></spr-section-module-icon>
<spr-section-module-info
	[isSuggestion]="module.isSuggestion"
	[pTooltip]="(module.instance.localization$ | async)?.suggestionText"
	[showSettings]="module.showSettings"
	(settingsClick)="onSettingsClick($event, module, moduleSettings)"
	tooltipPosition="right"
>
	<ng-container
		*ngIf="(module.instance.localization$ | async)?.title; else name"
	>
		{{ (module.instance.localization$ | async)?.title }}
	</ng-container>
	<ng-template #name>
		{{ (module.instance.localization$ | async)?.name }}
	</ng-template>
</spr-section-module-info>
<p-overlayPanel #moduleSettings appendTo="body">
	<spr-section-module-edit
		*ngIf="editingModule"
		[module]="editingModule"
		[panel]="moduleSettings"
	></spr-section-module-edit>
</p-overlayPanel>
